import React from "react";

const SectionTitle = ({ kicker, title, subtitle, center = true }) => (
  <div className={`${center ? "text-center" : "text-left"} mb-10`}>
    {kicker && (
      <span className="font-handwriting text-2xl text-deep-rose">{kicker}</span>
    )}
    <h2 className="font-serif-display text-4xl md:text-5xl text-stone-800 mt-1 tracking-wide">
      {title}
    </h2>
    <div className="section-divider mt-5" />
    {subtitle && (
      <p className="max-w-2xl mx-auto mt-5 text-stone-600 font-serif-display text-lg leading-relaxed">
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionTitle;
